// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_-hy58","bg":"index_bg_ebwV3"};